module.exports = __webpack_public_path__ + "img/img-i5gam-advantage-rp.4ffbb460.png";